<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTranslation_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M9.5 2c.64 0 1.169.483 1.241 1.104l.009.146V4.5H12a1.25 1.25 0 0 1 .146 2.491L12 7l-1.295.001c-.182 2.514-.906 4.8-2.016 6.55l-.073.11c1 .41 2.214.697 3.56.8l2.431-5.469c.395-.888 1.567-.979 2.122-.273l.09.133.074.14 5 11.25a1.25 1.25 0 0 1-2.218 1.145l-.068-.13-.78-1.757h-6.154l-.78 1.757c-.26.585-.917.873-1.514.686l-.137-.051a1.25 1.25 0 0 1-.685-1.513l.051-.137 1.501-3.378c-1.568-.206-3.008-.635-4.213-1.242C5.83 16.5 4.594 17 3.25 17a1.25 1.25 0 0 1-.146-2.492l.146-.008c.506 0 1.004-.145 1.478-.413-.938-.95-1.48-2.084-1.478-3.339a1.25 1.25 0 0 1 2.492-.142l.008.146c0 .54.268 1.08.753 1.575.882-1.334 1.514-3.194 1.694-5.326L3.25 7a1.25 1.25 0 0 1-.146-2.491L3.25 4.5h5V3.25C8.25 2.56 8.81 2 9.5 2m4.284 15h3.933l-1.966-4.424z"
    />
</svg>
